export const SCROLL_OBSERVER_ROOT_ID = 'data-scroll-observer-root-id';
export const SCROLL_OBSERVER_ENTRY_ID = 'data-scroll-observer-entry-id';
